import { render, staticRenderFns } from "./FamilyMemberDetailForm.vue?vue&type=template&id=ec9bb0e2&"
import script from "./FamilyMemberDetailForm.vue?vue&type=script&lang=js&"
export * from "./FamilyMemberDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports